import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { PageContainer } from "@toolpad/core/PageContainer";
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
// Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import SearchIcon from "@mui/icons-material/Search";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SupportIcon from '@mui/icons-material/Support';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LockResetIcon from '@mui/icons-material/LockReset';

// Local Components
import LocalDashBoard from "../../LocalComponenets/masterpages/DashBoard/LocalDashBoard";
import UserManage from "../../LocalComponenets/masterpages/AdminCompnent/UserManage/UserManage";
import SearchData from "../../LocalComponenets/masterpages/SearchDatafolder/SearchData";
import ChangePassword from "../../LocalComponenets/ChangePassword/ChangePassword";
import MediaCapture from "../../LocalComponenets/masterpages/EntryComponent/MediaCapture";
import MediaGallery from "../../LocalComponenets/masterpages/ReportComponent/MediaGallery";
import TrainAnimation from "../Animation/Trainanimation";
import DataReport from "../../LocalComponenets/masterpages/ReportComponent/DataReport";
import ReportMediaGallery from "../../LocalComponenets/masterpages/ReportComponent/ReportMediaGallery";




export default function DashboardLayoutBasic({ window }) {
  const [authSegments, setAuthSegments] = useState([]); // Initialize authSegments as an empty array
  const [updatedNavigation, setUpdatedNavigation] = useState([]);

const isMobile = useMediaQuery('(max-width:600px)');
  // Define the navigation structure here
  const NAVIGATION = [

    { kind: "header", title: "Main Items" },
    { segment: "dashboard", title: "Dashboard", icon: <DashboardIcon /> },

    { kind: "header", title: "Entry Sections" },
    {
      segment: "entry", title: "Entry", icon: <KeyboardIcon />, children: [
        { segment: "camera", title: "OBHS", icon: <TextFieldsIcon /> },

      ]
    },

    { kind: "header", title: "Only for Admin " },
    {
      segment: "admin", title: "Admin Area", icon: <AdminPanelSettingsIcon />, children: [
        { segment: "usermanage", title: "User Management", icon: <PersonAddAltIcon /> },
      ]
    },

    { segment: "details" },







    { kind: "header", title: "Analytics & Reports" },
    {
      segment: "reports", title: "Reports", icon: <BarChartIcon />, children: [
        { segment: "media", title: "Media Gallery", icon: <DescriptionIcon /> },
        { segment: "datareport", title: "Data Report", icon: <DescriptionIcon /> },
      ]
    },

    { kind: "header", title: "Search" },
    {
      segment: "searchmenu", title: "Search", icon: <SearchIcon />,
      children: [
        { segment: "search", title: "Search Data", icon: <SearchIcon /> },

      ]
    },


    { kind: "header", title: "Utilities" },
    {
      segment: "utilities", title: "Utilities", icon: <SupportIcon />, children: [
        { segment: "changepassword", title: "Change Password", icon: <LockResetIcon /> },
      ]
    },




    { kind: "header", title: "Logout" },
    { segment: "logout", title: "Logout", icon: <LogoutIcon /> }
  ];

  // Fetch user info and set authSegments using useEffect
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('token'));
    if (user && user.menurights) {
      const menuRightsArray = user.menurights.split(',');
      setAuthSegments(menuRightsArray); // Set authSegments as an array
    } else {
      setAuthSegments([]); // Fallback to empty array if no menurights
    }
  }, []);

  // Log the authSegments value
  useEffect(() => {
    // console.log('Updated authSegments:', authSegments);
  }, [authSegments]);

  useEffect(() => {
    if (!authSegments || !Array.isArray(authSegments)) {
      return;
    }

    const newNavigation = NAVIGATION.reduce((acc, item) => {
      if (item.children) {
        // Filter children based on authSegments
        item.children = item.children.filter(child => authSegments.includes(child.segment));
        if (item.children.length > 0 || item.segment === "dashboard" || item.segment === "logout" || item.segment === "utilities") {
          acc.push(item);
        }
      } else {
        if (authSegments.includes(item.segment) || item.segment === "dashboard" || item.segment === "logout") {
          acc.push(item);
        }
      }
      return acc;
    }, []);

    setUpdatedNavigation(newNavigation); // Update the navigation state
  }, [authSegments]); // Trigger whenever authSegments change

  // const demoTheme = createTheme({
  //   palette: { mode: "light" },
  //   typography: {
  //     fontFamily: "Roboto, sans-serif",
  //     fontSize: 12,
  //     h1: { fontSize: "2rem" },
  //     h2: { fontSize: "1.5rem" },
  //     h3: { fontSize: "1.25rem" },
  //     h4: { fontSize: "1.125rem" },
  //     h5: { fontSize: "1rem" },
  //     h6: { fontSize: "0.875rem" }
  //   }
  // });

  const demoTheme = createTheme({
  palette: { mode: "light" },
  typography: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 12,
    h1: { fontSize: "2rem" },
    h2: { fontSize: "1.5rem" },
    h3: { fontSize: "1.25rem" },
    h4: { fontSize: "1.125rem" },
    h5: { fontSize: "1rem" },
    h6: { fontSize: "0.875rem" },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          [`@media (max-width:600px)`]: {
            minHeight: '20px', // Reduce height on mobile
            height: '40px',
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          [`@media (max-width:600px)`]: {
            minHeight: '40px !important',
            paddingTop: '4px',
            paddingBottom: '4px',
          },
        },
      },
    },
  },
});


  function useDemoRouter(initialPath) {
    const [pathname, setPathname] = useState(initialPath);
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path))
    };
  }


  const router = useDemoRouter("/dashboard");
  const demoWindow = window ? window() : undefined;
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/"); // Navigate to logout
  };
  const [reportId, setReportId] = useState(null);

  const renderContent = () => {
    switch (router.pathname) {
      case "/dashboard": return <LocalDashBoard />;
      case "/entry/camera": return <MediaCapture />
      case "/reports/media": return <MediaGallery />
      case "/reports/datareport": return <DataReport router={router} setReportId={setReportId} />
      case "/utilities/changepassword": return <ChangePassword />
      case "/searchmenu/search": return <SearchData />
      case "/admin/usermanage": return <UserManage />;
      case "/details": return <ReportMediaGallery reportId={reportId} />;
      case "/logout": handleLogout(); return null;
      default: return <div style={{ fontWeight: 'bold', color: 'red', fontSize: '24px', textAlign: 'center' }}>
        Page Not Found
      </div>;
    }
  };


  return (
    <ThemeProvider theme={demoTheme}>
     <AppProvider
  navigation={updatedNavigation}
  router={router}
  branding={{
    title: isMobile ? "" : <TrainAnimation />,
    fullWidth: true,
    logo: "",
    homeUrl: "",
  }}
>
        <DashboardLayout>

          <PageContainer title="" breadcrumbs="">
            <div  >
              {renderContent()}
            </div>
          </PageContainer>
        </DashboardLayout>
      </AppProvider>

    </ThemeProvider>
  );
}
